import type { MarketCode, PlayerWithMarkets } from '@sharpr/types';

export interface AdminSummary { constructionMode: boolean; teams: string[]; markets: string[]; playerHides: number; releaseTime?: string }

// The admin view's banner: what it shows that subscribers don't, from its rows' reasons (each market's hiddenBy), with
// the sport's release time where it has one. Null when nothing is hidden.
export function adminSummary({ rows, constructionMode, releaseTime }: {
  rows: readonly PlayerWithMarkets[]; constructionMode: boolean; releaseTime?: string;
}): AdminSummary | null {
  const teams = new Set<string>();
  const markets = new Set<MarketCode>();
  let playerHides = 0;
  for (const p of rows) {
    for (const [market, d] of Object.entries(p.markets)) {
      if (d?.hiddenBy?.includes('team') && p.team) teams.add(p.team);
      if (d?.hiddenBy?.includes('sport')) markets.add(market as MarketCode);
      if (d?.hiddenBy?.includes('player')) playerHides += 1;
    }
  }
  if (!constructionMode && teams.size === 0 && markets.size === 0 && playerHides === 0) return null;
  return { constructionMode, teams: [...teams], markets: [...markets], playerHides, ...(releaseTime && { releaseTime }) };
}
